var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "header-main"
  }, [_c('b-navbar', {
    staticClass: "align-items-center justify-content-center",
    attrs: {
      "toggleable": "xl"
    }
  }, [_c('b-navbar-toggle', {
    staticClass: "navbar-toggle",
    attrs: {
      "target": "nav-collapse"
    },
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })]), _c('b-navbar-brand', {
    attrs: {
      "href": _vm.siteInfo.home_url || _vm.mainWebsiteUrl
    }
  }, [_vm.siteInfo.site_logo ? [_c('img', {
    staticClass: "black-logo",
    attrs: {
      "src": _vm.siteInfo.site_logo,
      "alt": _vm.siteInfo.name || 'MyWhoosh'
    }
  })] : [_c('strong', {
    staticClass: "black-logo site-name-fallback"
  }, [_vm._v(" " + _vm._s(_vm.siteInfo.name || "MyWhoosh") + " ")])], _vm.siteInfo.site_logo_dark ? [_c('img', {
    staticClass: "white-logo d-none",
    attrs: {
      "src": _vm.siteInfo.site_logo_dark,
      "alt": _vm.siteInfo.name || 'MyWhoosh'
    }
  })] : [_c('strong', {
    staticClass: "white-logo d-none site-name-fallback"
  }, [_vm._v(" " + _vm._s(_vm.siteInfo.name || "MyWhoosh") + " ")])]], 2), _c('b-collapse', {
    attrs: {
      "id": "nav-collapse",
      "is-nav": ""
    }
  }, [_c('b-navbar-nav', {
    staticClass: "w-100"
  }, [_vm._l(_vm.sortedMenuItems.filter(function (item) {
    return !_vm.hasChildren(item.ID);
  }), function (item) {
    return _c('b-nav-item', {
      key: item.ID,
      class: {
        split: item.classes.includes('split')
      },
      attrs: {
        "href": item.url,
        "target": item.target || '_self',
        "title": item.attr_title,
        "disabled": item.classes.includes('split')
      }
    }, [_vm._v(" " + _vm._s(item.classes.includes("split") ? "" : item.title) + " ")]);
  }), _vm._l(_vm.sortedMenuItems.filter(function (item) {
    return _vm.hasChildren(item.ID);
  }), function (item) {
    return _c('b-nav-item-dropdown', {
      key: item.ID,
      attrs: {
        "right": ""
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function () {
          return [_vm._v(" " + _vm._s(item.title) + " ")];
        },
        proxy: true
      }], null, true)
    }, _vm._l(_vm.getChildren(item.ID), function (child) {
      return _c('b-dropdown-item', {
        key: child.ID,
        attrs: {
          "href": child.url,
          "target": child.target || '_self',
          "title": child.attr_title
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")]);
    }), 1);
  }), _vm.loggedIn ? [_c('b-nav-item', {
    staticClass: "d-xl-none",
    attrs: {
      "to": {
        name: 'new_activities',
        hash: '#profile'
      }
    }
  }, [_vm._v(" View Profile ")]), _c('b-nav-item', {
    staticClass: "d-xl-none",
    attrs: {
      "to": {
        name: 'new_activities',
        hash: '#activities'
      }
    }
  }, [_vm._v(" Activities ")]), _c('b-nav-item', {
    staticClass: "d-xl-none",
    attrs: {
      "to": {
        name: 'my_teams'
      }
    }
  }, [_vm._v(" My Teams ")]), !_vm.isKid ? _c('b-nav-item', {
    staticClass: "d-xl-none",
    attrs: {
      "to": {
        name: 'userWallet'
      }
    }
  }, [_vm._v(" Wallet ")]) : _vm._e(), _c('b-nav-item', {
    staticClass: "d-xl-none",
    attrs: {
      "to": {
        name: 'seasons'
      }
    }
  }, [_vm._v(" Seasons ")]), _c('b-nav-item', {
    staticClass: "d-xl-none",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" Log Out ")]), _c('b-nav-item-dropdown', {
    staticClass: "user-account d-none d-xl-block",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('em', [_vm._v(_vm._s(_vm.user.firstname.substring(0, 1)))])];
      },
      proxy: true
    }], null, false, 676812876)
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'new_activities',
        hash: '#profile'
      }
    }
  }, [_vm._v(" View Profile ")]), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'userVaultRewards'
      }
    }
  }, [_vm._v(" My Rewards ")]), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'new_activities',
        hash: '#activities'
      }
    }
  }, [_vm._v(" Activities ")]), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'my_teams'
      }
    }
  }, [_vm._v(" My Teams ")]), !_vm.isKid ? _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'userWallet'
      }
    }
  }, [_vm._v(" Wallet ")]) : _vm._e(), _c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'seasons'
      }
    }
  }, [_vm._v(" Seasons ")]), _c('b-dropdown-item', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" Log Out ")])], 1)] : [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Login")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }